import { Component, inject } from '@angular/core';
import { AppCheckErrorService } from './_services/app-check-error.service';
import { DevFormFillService } from './_services/dev-form-fill.service';
import { ShellComponent } from './_shell/shell.component';

/** Root bootstrap only — layout lives in `app-shell`. */
@Component({
  selector: 'app-root',
  template: '<app-shell />',
  standalone: true,
  imports: [ShellComponent],
})
export class AppComponent {
  /** Instantiates DevFormFillService so the Ctrl/Cmd+Shift+D listener registers (no-op in prod). */
  private readonly devFormFill = inject(DevFormFillService);

  constructor() {
    inject(AppCheckErrorService).startTokenMonitoring();
  }
}
